import { render } from "./DynamicCard.vue?vue&type=template&id=4ea1959f"
import script from "./DynamicCard.vue?vue&type=script&lang=js"
export * from "./DynamicCard.vue?vue&type=script&lang=js"

import exportComponent from "/Users/nogglema/Documents/Ecampus/css-205-lab-2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__